import React from "react";

const EnterprisePricingTable = ({ plans, onBuy }) => {
  const features = [
    { label: "Ideal For", key: "ideal" },
    { label: "Searches", key: "searches" },
    { label: "Profile Views", key: "views" },
    { label: "Job Postings", key: "jobs" },
    { label: "Emailers", key: "emails" },
    { label: "Validity", key: "validity" }
  ];

  return (
    <div className="w-full">

      {/* ================= DESKTOP / TABLE VIEW ================= */}
      <div className="hidden md:block overflow-x-auto overflow-visible">


       <div className="min-w-[1100px] bg-white rounded-b-2xl shadow-md border border-gray-200 overflow-visible">




          {/* Header Row */}
          <div className="grid grid-cols-5 border-b border-gray-200 bg-gray-50 pt-6">


           <div className="p-6 font-semibold text-gray-700 sticky left-0 bg-gray-50 z-20">

              Services
            </div>

            {plans.map((plan, idx) => (
              <div
                key={idx}
                className={`p-6 pt-10 text-center relative flex flex-col items-center justify-start
${plan.highlight
  ? "bg-white border border-purple-400 ring-1 ring-purple-300 rounded-t-xl shadow-lg scale-[1.03] z-10"
  : "border-l"
}`}

              >
                {plan.highlight && (
                <div className="absolute top-3 left-1/2 -translate-x-1/2 
bg-gradient-to-r from-purple-600 to-indigo-600 
text-white text-[11px] px-5 py-1.5 rounded-full 
shadow-lg font-semibold tracking-wide">
  RECOMMENDED
</div>


                )}

                <h3 className="text-sm font-bold text-gray-800 mb-2">
                  {plan.name.toUpperCase()}
                </h3>

                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs text-gray-400 line-through">
                    {plan.oldPrice}
                  </span>
                  <span className="text-xs text-green-600 font-semibold">
                    {plan.off}
                  </span>
                </div>

               <div className="text-2xl font-bold text-gray-900 mb-4">

                  {plan.price}
                </div>

                <button
                  onClick={() => onBuy(plan)}
                  className={`px-6 py-2 rounded-md font-semibold transition shadow-sm text-sm
                  ${plan.highlight
  ? "bg-purple-50/50 border-l border-r border-purple-300 font-semibold text-gray-900"
                    : "bg-orange-500 hover:bg-orange-600 text-white"
                  }`}
                >
                  Buy Now
                </button>

                {plan.note && (
                  <p className="text-purple-600 text-xs mt-3 font-medium">
                    {plan.note}
                  </p>
                )}
              </div>
            ))}
          </div>

          {/* Feature Rows */}
          {features.map((feature, rowIdx) => (
            <div
              key={rowIdx}
              className={`grid grid-cols-5 text-sm
              ${rowIdx % 2 === 0 ? "bg-white" : "bg-gray-50"}`}
            >
              <div className="p-4 font-semibold text-gray-700 sticky left-0 bg-inherit z-10 border-t">

                {feature.label}
              </div>

              {plans.map((plan, colIdx) => (
                <div
                  key={colIdx}
                  className={`p-4 text-center border-t
                  ${plan.highlight
                    ? "bg-purple-50/40 border-l border-r border-purple-300 bg-purple-50/50 font-semibold text-gray-900"
                    : "border-l text-gray-700"
                  }`}
                >
                  {plan[feature.key]}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* ================= MOBILE / CARD VIEW ================= */}
      <div className="md:hidden space-y-6">

        {plans.map((plan, idx) => (
          <div
            key={idx}
            className={`bg-white rounded-2xl shadow-md border p-6 relative
            ${plan.highlight ? "border-purple-500 shadow-lg" : "border-gray-200"}`}
          >
            {plan.highlight && (
              <div className="absolute -top-3 right-4 bg-purple-600 text-white text-xs px-3 py-1 rounded-full">
                Recommended
              </div>
            )}

            {/* Header */}
            <h3 className="text-lg font-bold text-gray-900 mb-2">
              {plan.name}
            </h3>

            {/* Price */}
            <div className="flex items-center gap-2 mb-2">
              <span className="text-sm text-gray-400 line-through">
                {plan.oldPrice}
              </span>
              <span className="text-sm text-green-600 font-semibold">
                {plan.off}
              </span>
            </div>

            <div className="text-3xl font-bold text-gray-900 mb-4">
              {plan.price}
            </div>

            {/* Features */}
            <div className="space-y-2 text-sm text-gray-700 mb-5">
              {features.map((feature) => (
                <div key={feature.key} className="flex justify-between">
                  <span className="font-medium text-gray-600">
                    {feature.label}
                  </span>
                  <span className="font-semibold">
                    {plan[feature.key]}
                  </span>
                </div>
              ))}
            </div>

            {/* Button */}
            <button
              onClick={() => onBuy(plan)}
              className={`w-full py-2.5 rounded-lg font-semibold transition
              ${plan.highlight
                ? "bg-purple-600 hover:bg-purple-700 text-white"
                : "bg-orange-500 hover:bg-orange-600 text-white"
              }`}
            >
              Buy Now
            </button>

            {plan.note && (
              <p className="text-purple-600 text-sm mt-3 text-center font-medium">
                {plan.note}
              </p>
            )}
           

          </div>
        ))}
        
      </div>
    </div>
  );
};

export default EnterprisePricingTable;
